/* =====================================================================
   Cookiehaus Lead-Funnels für Großbestellungen (Vereine, Firmen, Kitas, Gemeinden)
   - <keks-lead data-modus="seite">  page.mengenanfrage  (alles auf einer Seite)
   - <keks-lead data-modus="quiz">   page.angebot         (eine Frage je Bildschirm)
   - <keks-lead-danke>                page.anfrage-danke   (Zusammenfassung aus sessionStorage)

   Absenden: Shopify-Kontaktformular (/contact) mit denselben Feldern wie „Vereine & Firmen“, Felder siehe
   snippets/keks-lead-teile.liquid (teil 'versteckt'). Klassisch abgeschickt, damit Shopifys hCaptcha sein Token
   setzen kann (per fetch ohne Token antwortet Shopify „Missing CAPTCHA token“, getestet 17.10.2026). Danach
   return_to bzw. ?contact_posted=true auf der Funnel-Seite: weiter auf /pages/anfrage-danke.
   ===================================================================== */
(() => {
  'use strict';

  /* Staffelpreise Vereine & Firmen in EUR brutto je Ausstecher, nach Stückzahl je Motiv.
     MUSS zu angebot_anlegen.STAFFEL im Repo lmck16/keksausstecher passen:
     STAFFEL = ((1000, 2.50), (500, 3.50), (250, 4.50), (100, 5.50), (50, 6.90)). Unter 50 kein Angebot. */
  const STAFFEL = [[1000, 2.5], [500, 3.5], [250, 4.5], [100, 5.5], [50, 6.9]];
  const AB = 50;
  const SHOP_ERSTER = 29.9; // Eigenes Motiv im Shop: erster Ausstecher
  const SHOP_KOPIE = 7.9; //   jede weitere Kopie
  const WERKTAGE_MIN = 12; // frühestes Datum im Datumsfeld (Entwurf + Freigabe + 10 Werktage Lieferung)
  const WERKTAGE_KNAPP = 15; // bis dahin: freundlicher Hinweis „knapp“
  const SPEICHER = 'keks_lead';
  const HERKUNFT = 'keks_lead_herkunft';
  const KONVERSION = 'keks_lead_konversion';
  const HERKUNFT_FELDER = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'fbclid'];
  const ANFRAGEART = 'Angebot für unser Wappen oder Logo';
  const ANFRAGEART_VIEL = 'Preisliste über 1.000 Stück';

  const euro = (n) => n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  const zahl = (n) => n.toLocaleString('de-DE');
  const preisJe = (m) => {
    const s = STAFFEL.find(([ab]) => m >= ab);
    return s ? s[1] : null;
  };
  const naechste = (m) => STAFFEL.slice().reverse().find(([ab]) => ab > m) || null;

  /* Messung je Schritt (19.10.2026): Vorher sah nur „Seite aufgerufen“, wer wo aussteigt, blieb unsichtbar.
     1. Eigener Pixel: wie der Shopify-Pixel an /p/k als page_viewed mit Pfad /pages/<funnel>/<schritt>, nur wenn
        das Cookie ch_b da ist (das legt erst der Pixel nach Einwilligung an).
     2. Meta: Ereignis „LeadSchritt“ {funnel, schritt} an den Pixel der Lead-Kampagnen (LocalReseller), nur mit
        Marketing-Einwilligung und nur, wenn fbq auf der Seite schon geladen ist. Daraus die benutzerdefinierte
        Conversion „Lead Kontaktschritt“ als Zwischenziel, solange es zu wenige Anfragen zum Lernen gibt.
     Jeder Schritt zählt je Seitenaufruf einmal. */
  const PIXEL_ZIEL = 'https://produktion.cookiehaus.de/p/k';
  const META_PIXEL = '1801786577514365';
  const gemessen = new Set();
  let metaBereit = false;
  function marketingErlaubt() {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed());
  }
  function messen(funnel, schritt) {
    const k = `${funnel}:${schritt}`;
    if (gemessen.has(k)) return;
    gemessen.add(k);
    try {
      const b = (document.cookie.match(/(?:^|;\s*)ch_b=([^;]+)/) || [])[1];
      if (b)
        fetch(PIXEL_ZIEL, {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify({
            art: 'page_viewed',
            b: decodeURIComponent(b),
            token: `lead${funnel}${schritt}${Date.now().toString(36)}`.replace(/[^A-Za-z0-9_-]/g, '').slice(0, 80),
            pfad: `/pages/${funnel === 'quiz' ? 'angebot' : 'mengenanfrage'}/${schritt}`,
          }),
        }).catch(() => {});
    } catch (e) {}
    try {
      if (typeof window.fbq !== 'function' || !marketingErlaubt()) return;
      if (!metaBereit) {
        window.fbq('init', META_PIXEL);
        metaBereit = true;
      }
      window.fbq('trackSingleCustom', META_PIXEL, 'LeadSchritt', { funnel, schritt });
    } catch (e) {}
  }
  function messenWennBereit(funnel, schritt) {
    // customerPrivacy kommt erst mit Shopify.loadFeatures; ohne es zählt nur der eigene Pixel (der fragt selbst nichts).
    if (window.Shopify && window.Shopify.customerPrivacy) return messen(funnel, schritt);
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function')
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => messen(funnel, schritt));
    else messen(funnel, schritt);
  }

  function lesen(k) {
    try {
      return JSON.parse(sessionStorage.getItem(k) || 'null');
    } catch (e) {
      return null;
    }
  }
  function schreiben(k, v) {
    try {
      sessionStorage.setItem(k, typeof v === 'string' ? v : JSON.stringify(v));
    } catch (e) {
      /* privat oder voll: geht auch ohne */
    }
  }

  /* Herkunft aus der Landing-URL; bleibt für die Sitzung, falls innerhalb des Shops weitergeklickt wird. */
  function herkunft() {
    let h = lesen(HERKUNFT) || {};
    try {
      const q = new URLSearchParams(location.search);
      if (HERKUNFT_FELDER.some((f) => q.get(f))) {
        h = {};
        HERKUNFT_FELDER.forEach((f) => {
          const v = q.get(f);
          if (v) h[f] = v.slice(0, 250);
        });
        schreiben(HERKUNFT, h);
      }
    } catch (e) {
      /* alte Browser */
    }
    return h;
  }

  /* ---------- Datum ---------- */
  function heute() {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }
  function plusWerktage(start, n) {
    const d = new Date(start);
    let w = 0;
    while (w < n) {
      d.setDate(d.getDate() + 1);
      const t = d.getDay();
      if (t !== 0 && t !== 6) w += 1;
    }
    return d;
  }
  const iso = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  function ausIso(s) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || '');
    return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null;
  }
  const datumText = (d) => d.toLocaleDateString('de-DE', { day: 'numeric', month: 'long', year: 'numeric' });
  const datumKurz = (d) => d.toLocaleDateString('de-DE', { day: 'numeric', month: 'long' });
  /* Schnellauswahl: Datum im laufenden Jahr; ist es vorbei, gibt es die Wahl nicht. */
  function schnellDatum(art) {
    const j = heute().getFullYear();
    if (art === 'Ende November') return new Date(j, 10, 30);
    if (art === 'Mitte Dezember') return new Date(j, 11, 15);
    return null;
  }

  /* Das eigene Rubbellos-Pop-up (em/cookiehaus.js vom Server, Exit-Intent, Rabattcode für Shop-Bestellungen; Stand
     17.10.2026 abgeschaltet, es läuft noch das Klaviyo-Formular UuDHha, das man nur in Klaviyo per URL ausschließen
     kann) passt nicht in den Anfrage-Funnel und verdeckt am Handy das Formular. Es pausiert, solange das Cookie ch_zu (Zeitpunkt in ms) in
     der Zukunft liegt, so wie nach dem Schließen. Hier: 2 Stunden ab dem Besuch einer Funnel-Seite. */
  function popupPause() {
    try {
      const bis = Date.now() + 2 * 3600e3;
      const m = document.cookie.match(/(?:^|; )ch_zu=(\d+)/);
      if (!m || +m[1] < bis) document.cookie = `ch_zu=${bis}; path=/; max-age=7200; SameSite=Lax`;
    } catch (e) {
      /* Cookies gesperrt: dann eben mit Pop-up */
    }
  }

  /* Klaviyo-Onsite-Formulare (Pop-up, Vollbild, Flyout, Teaser) gehören nicht in den Funnel: Am Handy öffnet Klaviyo
     das Rubbellos-Pop-up (UuDHha) schon beim ersten Hochwischen und sperrt mit der Klasse
     klaviyo-prevent-body-scrolling das Scrollen, auch während snippets/cookiehaus-rubbellos.liquid es 25 s versteckt.
     Hier: Container sofort und dauerhaft ausblenden (auch nachgeladene, MutationObserver) und die Scroll-Sperre an
     body/html gleich wieder lösen. Klaviyos Skript und Tracking laufen unverändert weiter. Gilt nur auf den
     Funnel-Seiten, weil nur sie diese Datei laden. Dauerhaft sauberer: die drei Seiten in Klaviyo ausschließen. */
  const KLAVIYO_FORM = '[data-testid^="klaviyo-form-"], [role="dialog"][class*="kl-private-reset-css"], [class*="kl-teaser"]';
  function klaviyoAbschirmen() {
    if (window.__klAbschirmen) return;
    window.__klAbschirmen = true;
    const huelle = (el) => {
      let e = el;
      while (e.parentElement && e.parentElement !== document.body) e = e.parentElement;
      return e;
    };
    const ausblenden = () => {
      document.querySelectorAll(KLAVIYO_FORM).forEach((el) => {
        // Nur schwebende Formulare: eingebettete Klaviyo-Formulare im Seiteninhalt gibt es hier nicht, sicher ist sicher.
        if (el.closest('keks-lead, keks-lead-danke, main')) return;
        const h = huelle(el);
        if (h === document.body || h.matches('keks-lead, keks-lead-danke')) return;
        if (h.style.getPropertyValue('display') !== 'none' || h.style.getPropertyPriority('display') !== 'important') {
          h.style.setProperty('display', 'none', 'important');
        }
        h.dataset.klFunnelAus = '1';
      });
    };
    const entsperren = () => {
      [document.body, document.documentElement].forEach((el) => {
        if (!el) return;
        if (el.classList.contains('klaviyo-prevent-body-scrolling')) el.classList.remove('klaviyo-prevent-body-scrolling');
        // Inline-Sperre nur lösen, wenn ein Klaviyo-Formular da ist (die Schubladen des Shops sperren auch, die bleiben).
        if (document.querySelector('[data-kl-funnel-aus]') && el.style.overflow === 'hidden') {
          const top = parseInt(el.style.top, 10);
          ['overflow', 'position', 'top', 'width'].forEach((x) => el.style.removeProperty(x));
          if (top < 0) window.scrollTo(0, -top);
        }
      });
    };
    const pruefen = () => {
      ausblenden();
      entsperren();
    };
    pruefen();
    const beobachter = new MutationObserver(pruefen);
    const starten = () => {
      beobachter.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
      beobachter.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
    };
    if (document.body) starten();
    else document.addEventListener('DOMContentLoaded', starten);
  }
  klaviyoAbschirmen();

  /* Texte, die sich nach „Für wen“ richten */
  const ORG_LABEL = {
    Sportverein: 'Name des Vereins',
    'Feuerwehr / THW': 'Name der Feuerwehr oder des THW',
    'Gemeinde / Heimatverein': 'Name der Gemeinde oder des Vereins',
    'Kita / Schule': 'Name der Kita oder Schule',
    'Firma / Praxis': 'Name der Firma oder Praxis',
    'Anderer Verein': 'Name des Vereins',
  };
  const ANLASS_TEXT = {
    geschenk: { 'Firma / Praxis': 'Geschenk für Kunden oder Team', 'Kita / Schule': 'Geschenk für alle Kinder', 'Gemeinde / Heimatverein': 'Geschenk für alle im Ort', '': 'Geschenk für alle Mitglieder' },
    fest: { 'Firma / Praxis': 'Firmenfest oder Messe', 'Kita / Schule': 'Kita- oder Schulfest', '': 'Turnier oder Fest' },
    verkauf: { 'Firma / Praxis': 'Verkauf im Laden', '': 'Verkauf (Basar, Theke)' },
  };

  class KeksLead extends HTMLElement {
    connectedCallback() {
      if (this.bereit) return;
      this.bereit = true;
      this.modus = this.dataset.modus === 'quiz' ? 'quiz' : 'seite';
      this.wurzel = this.dataset.wurzel || '';
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.setAttribute('novalidate', '');

      // Rückkehr nach klassischem Absenden (Shopify: ?contact_posted=true): weiter zur Danke-Seite.
      if (/[?&]contact_posted=true/.test(location.search)) {
        const p = lesen(SPEICHER);
        if (p && p.ziel && p.offen) {
          p.offen = false;
          schreiben(SPEICHER, p);
          location.replace(p.ziel);
          return;
        }
      }

      popupPause();
      this.a = { wer: '', anlass: '', anlassText: '', menge: AB, terminArt: '', datum: '' };
      this.herkunft = herkunft();
      this.feld = (k) => this.form.querySelector(`[data-kl-feld="${k}"]`);
      this.eingabe = (k) => this.form.querySelector(`[data-kl-eingabe="${k}"]`);

      this.kachelnEinrichten();
      this.mengeEinrichten();
      this.terminEinrichten();
      this.kontaktEinrichten();
      this.uploadBeobachten();
      if (this.modus === 'quiz') this.quizEinrichten();
      else this.seiteEinrichten();
      this.form.addEventListener('submit', (e) => this.absenden(e));
      this.rechne();
      this.felder();
    }

    /* ---------- Kacheln: Für wen, Anlass ---------- */
    kachelnEinrichten() {
      this.querySelectorAll('[data-kl-wahl]').forEach((knopf) => {
        knopf.addEventListener('click', () => {
          const art = knopf.dataset.klWahl;
          this.querySelectorAll(`[data-kl-wahl="${art}"]`).forEach((k) => k.setAttribute('aria-pressed', String(k === knopf)));
          if (art === 'wer') {
            this.a.wer = knopf.dataset.wert;
            this.texteAnpassen();
            this.fehler('wer', '');
          } else {
            this.a.anlass = knopf.dataset.wert;
            this.a.anlassText = knopf.textContent.trim();
          }
          this.felder();
          if (this.modus === 'quiz') this.spaeterWeiter();
        });
      });
    }

    texteAnpassen() {
      const w = this.a.wer;
      Object.keys(ANLASS_TEXT).forEach((k) => {
        const el = this.querySelector(`[data-kl-text="${k}"]`);
        if (el) el.textContent = ANLASS_TEXT[k][w] || ANLASS_TEXT[k][''];
      });
      const gewaehlt = this.querySelector('[data-kl-wahl="anlass"][aria-pressed="true"]');
      if (gewaehlt) this.a.anlassText = gewaehlt.textContent.trim();
      const label = this.querySelector('[data-kl-org-label]');
      if (label) label.textContent = ORG_LABEL[w] || 'Name des Vereins oder der Firma';
    }

    /* ---------- Stückzahl und Preis ---------- */
    mengeEinrichten() {
      this.mengeFeld = this.querySelector('[data-kl-menge]');
      this.regler = this.querySelector('[data-kl-regler]');
      const chips = this.querySelector('[data-kl-chips]');
      if (chips) {
        chips.innerHTML = STAFFEL.slice()
          .reverse()
          .map(([ab, p]) => `<button type="button" class="kl-chip" data-kl-chip="${ab}">ab ${zahl(ab)}: ${euro(p)}</button>`)
          .join('');
        chips.addEventListener('click', (e) => {
          const c = e.target.closest('[data-kl-chip]');
          if (c) this.setzeMenge(+c.dataset.klChip);
        });
      }
      if (this.mengeFeld) {
        this.mengeFeld.addEventListener('input', () => {
          const n = parseInt(this.mengeFeld.value.replace(/\D/g, ''), 10) || 0;
          this.a.menge = n;
          this.rechne(true);
        });
        this.mengeFeld.addEventListener('blur', () => {
          if (this.a.menge) this.mengeFeld.value = String(this.a.menge);
        });
        this.mengeFeld.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.mengeFeld.blur();
          }
        });
      }
      if (this.regler) this.regler.addEventListener('input', () => this.setzeMenge(+this.regler.value, true));
      const minus = this.querySelector('[data-kl-minus]');
      const plus = this.querySelector('[data-kl-plus]');
      if (minus) minus.addEventListener('click', () => this.setzeMenge(Math.max(10, (this.a.menge || AB) - 10)));
      if (plus) plus.addEventListener('click', () => this.setzeMenge((this.a.menge || 0) + 10));
      const tippKnopf = this.querySelector('[data-kl-tipp-knopf]');
      if (tippKnopf) tippKnopf.addEventListener('click', () => this.setzeMenge(+tippKnopf.dataset.menge));
    }

    setzeMenge(n, vomRegler) {
      this.a.menge = Math.max(0, Math.round(n));
      if (this.mengeFeld) this.mengeFeld.value = String(this.a.menge);
      this.rechne(!vomRegler);
    }

    rechne(reglerNachziehen = true) {
      const n = this.a.menge;
      const p = preisJe(n);
      if (this.regler && reglerNachziehen) this.regler.value = String(Math.min(Math.max(n, AB), 1000));
      this.querySelectorAll('[data-kl-chip]').forEach((c) => c.setAttribute('aria-current', String(+c.dataset.klChip === STAFFEL.find(([ab]) => n >= ab)?.[0])));
      const setze = (sel, text) => this.querySelectorAll(sel).forEach((el) => (el.textContent = text));
      const tipp = this.querySelector('[data-kl-tipp]');
      const wenig = this.querySelector('[data-kl-wenig]');
      const viel = this.querySelector('[data-kl-viel]');
      if (viel) viel.hidden = !(n > 1000);
      if (!n) {
        setze('[data-kl-gesamt]', '–');
        setze('[data-kl-stueckpreis]', '–');
        setze('[data-kl-je]', 'Bitte eine Stückzahl eingeben');
        if (tipp) tipp.hidden = true;
        if (wenig) wenig.hidden = true;
      } else if (!p) {
        setze('[data-kl-gesamt]', 'unter 50 Stück');
        setze('[data-kl-stueckpreis]', 'unter 50 Stück');
        setze('[data-kl-je]', `Im Shop: ${euro(SHOP_ERSTER)} für den ersten, jede weitere Kopie ${euro(SHOP_KOPIE)}`);
        if (tipp) tipp.hidden = true;
        if (wenig) wenig.hidden = false;
      } else {
        // Groß der Stückpreis wie in der Anzeige („ab 50 Stück je 6,90 €“), die Summe darunter.
        setze('[data-kl-gesamt]', euro(n * p));
        setze('[data-kl-stueckpreis]', euro(p));
        setze('[data-kl-je]', `${zahl(n)} Stück zusammen ${euro(n * p)} inkl. MwSt.`);
        if (wenig) wenig.hidden = true;
        const nx = naechste(n);
        if (tipp) {
          if (nx && nx[0] - n <= Math.max(20, n * 0.35)) {
            const jetzt = n * p;
            const dann = nx[0] * nx[1];
            this.querySelector('[data-kl-tipp-text]').textContent =
              dann <= jetzt
                ? `Tipp: ${zahl(nx[0])} Stück kosten mit ${euro(dann)} sogar weniger als ${zahl(n)} Stück.`
                : `Tipp: Ab ${zahl(nx[0])} Stück nur ${euro(nx[1])} je Ausstecher, zusammen ${euro(dann)}.`;
            const k = this.querySelector('[data-kl-tipp-knopf]');
            k.textContent = `Auf ${zahl(nx[0])} erhöhen`;
            k.dataset.menge = String(nx[0]);
            tipp.hidden = false;
          } else tipp.hidden = true;
        }
      }
      // Übersicht und Leiste (Seite)
      setze('[data-kl-zeige="menge"]', n ? zahl(n) : 'noch offen');
      setze('[data-kl-zeige="gesamt"]', p ? euro(n * p) : n ? 'unter 50 Stück' : '–');
      setze('[data-kl-zeige="je"]', p ? `je ${euro(p)} inkl. MwSt., Versand frei Haus` : 'Mengenpreis ab 50 Stück');
      setze('[data-kl-zeige="kurz"]', p ? `${zahl(n)} Stück, je ${euro(p)}` : 'Mengenpreis ab 50 Stück');
      const w = this.querySelector('[data-kl-weiter]');
      if (this.modus === 'quiz' && w && w.closest('[data-kl-schritt="menge"]')) w.disabled = !n;
      this.felder();
    }

    preisVorschau() {
      const n = this.a.menge;
      const p = preisJe(n);
      if (!n) return '';
      if (!p) return `${zahl(n)} Stück: unter 50, kein Mengenpreis`; // kurz halten: Shopify bricht lange Zeilen in der Mail um
      return `${zahl(n)} × ${euro(p)} = ${euro(n * p)} brutto`;
    }

    /* ---------- Termin ---------- */
    terminEinrichten() {
      this.datumFeld = this.querySelector('[data-kl-datum]');
      const min = plusWerktage(heute(), WERKTAGE_MIN);
      if (this.datumFeld) {
        this.datumFeld.min = iso(min);
        this.datumFeld.addEventListener('change', () => this.datumGewaehlt());
        this.datumFeld.addEventListener('input', () => this.datumGewaehlt());
      }
      this.querySelectorAll('[data-kl-termin]').forEach((knopf) => {
        const art = knopf.dataset.klTermin;
        const d = schnellDatum(art);
        if (d) {
          if (d < heute()) {
            knopf.hidden = true;
            return;
          }
          const zusatz = knopf.querySelector('[data-kl-termin-zusatz]');
          if (zusatz) zusatz.textContent = d < plusWerktage(heute(), WERKTAGE_KNAPP) ? `${datumKurz(d)}, das wird knapp` : datumKurz(d);
        }
        knopf.addEventListener('click', () => {
          this.querySelectorAll('[data-kl-termin]').forEach((k) => k.setAttribute('aria-pressed', String(k === knopf)));
          this.a.terminArt = art;
          const feld = this.querySelector('[data-kl-datum-feld]');
          const weiter = this.querySelector('[data-kl-datum-weiter]');
          if (art === 'eigenes Datum') {
            if (feld) feld.hidden = false;
            if (weiter) weiter.hidden = false;
            this.a.datum = this.datumFeld && this.datumFeld.value ? this.datumFeld.value : '';
            this.knappPruefen();
            if (this.datumFeld) {
              this.datumFeld.focus();
              try {
                if (this.datumFeld.showPicker) this.datumFeld.showPicker();
              } catch (e) {
                /* nicht erlaubt: Feld ist trotzdem da */
              }
            }
          } else {
            if (feld) feld.hidden = true;
            if (weiter) weiter.hidden = true;
            this.a.datum = d ? iso(d) : '';
            this.knappPruefen();
            if (this.modus === 'quiz') this.spaeterWeiter();
          }
          this.felder();
        });
      });
    }

    datumGewaehlt() {
      this.a.datum = this.datumFeld.value || '';
      this.knappPruefen();
      const weiter = this.querySelector('[data-kl-datum-weiter]');
      if (weiter) weiter.disabled = !ausIso(this.a.datum);
      this.felder();
    }

    knappPruefen() {
      const hinweis = this.querySelector('[data-kl-knapp]');
      if (!hinweis) return;
      const d = ausIso(this.a.datum);
      hinweis.hidden = !(d && d < plusWerktage(heute(), WERKTAGE_KNAPP));
    }

    terminText() {
      const d = ausIso(this.a.datum);
      if (this.a.terminArt === 'flexibel') return 'flexibel';
      if (d) return `bis ${datumText(d)}`;
      return '';
    }

    /* ---------- Kontakt ---------- */
    kontaktEinrichten() {
      this.querySelectorAll('[data-kl-eingabe]').forEach((el) =>
        el.addEventListener('input', () => {
          el.removeAttribute('aria-invalid');
          this.felder();
        })
      );
    }

    uploadBeobachten() {
      this.upload = this.querySelector('keks-upload');
      this.dateiLink = this.upload ? this.upload.querySelector('[data-link]') : null;
      if (!this.upload) return;
      // Der Upload-Baustein (keks-shop.js) setzt den Link ohne Ereignis: kurz nachsehen, solange etwas läuft.
      const pruefen = () => {
        if (!this.upload.laeuft) clearInterval(this.uploadUhr);
        const link = this.dateiLink ? this.dateiLink.value : '';
        if (link !== this.letzterLink) {
          this.letzterLink = link;
          this.felder();
          const weiter = this.querySelector('[data-kl-logo-weiter]');
          if (weiter) weiter.disabled = !link;
          const spaeter = this.querySelector('[data-kl-spaeter]');
          if (spaeter) spaeter.hidden = Boolean(link);
        }
      };
      this.upload.addEventListener('change', () => {
        clearInterval(this.uploadUhr);
        this.uploadUhr = setInterval(pruefen, 400);
      });
      this.upload.addEventListener('click', () => setTimeout(pruefen, 50));
      this.upload.addEventListener('drop', () => {
        clearInterval(this.uploadUhr);
        this.uploadUhr = setInterval(pruefen, 400);
      });
    }

    dateiName() {
      const link = this.dateiLink ? this.dateiLink.value : '';
      if (!link) return '';
      try {
        return decodeURIComponent(link.split('/').pop());
      } catch (e) {
        return link.split('/').pop();
      }
    }

    /* Alle versteckten contact[...]-Felder aus dem aktuellen Stand */
    felder() {
      if (!this.form || !this.a) return;
      const setze = (k, v) => {
        const el = this.feld(k);
        if (el) el.value = v == null ? '' : String(v);
      };
      const wert = (k) => {
        const el = this.eingabe(k);
        return el ? el.value.trim() : '';
      };
      const n = this.a.menge;
      const art = n > 1000 ? ANFRAGEART_VIEL : ANFRAGEART;
      const org = wert('organisation');
      setze('subject', `Vereine & Firmen: ${art}`);
      setze('name', org);
      setze('anfrageart', art);
      setze('stueckzahl', n ? String(n) : '');
      setze('gebraucht_bis', this.a.terminArt === 'flexibel' ? '' : this.a.datum);
      setze('termin_art', this.a.terminArt);
      setze('email', wert('email'));
      setze('fuer_wen', this.a.wer);
      setze('anlass', this.a.anlassText || this.a.anlass);
      setze('organisation', org);
      setze('ansprechpartner', wert('ansprechpartner'));
      setze('telefon', wert('telefon'));
      setze('preis_vorschau', this.preisVorschau());
      HERKUNFT_FELDER.forEach((f) => setze(f, this.herkunft[f] || ''));
      setze('body', wert('body'));
      setze('datei', this.dateiLink ? this.dateiLink.value : '');
      setze('return_to', this.zielAdresse());
      // Übersicht (Seite)
      const zeige = (k, t) => this.querySelectorAll(`[data-kl-zeige="${k}"]`).forEach((el) => (el.textContent = t));
      zeige('wer', this.a.wer || 'noch offen');
      zeige('anlass', this.a.anlassText || 'noch offen');
      zeige('termin', this.terminText() || 'noch offen');
      zeige('logo', this.dateiLink && this.dateiLink.value ? 'hochgeladen' : 'kommt später');
    }

    zielAdresse() {
      return `${this.wurzel}/pages/anfrage-danke?funnel=${this.modus}&menge=${this.a.menge || 0}`;
    }

    fehler(k, text) {
      const el = this.querySelector(`[data-kl-fehler="${k}"]`);
      if (!el) return;
      el.textContent = text || el.textContent;
      el.hidden = !text;
    }

    pruefen() {
      const fehlt = [];
      const org = this.eingabe('organisation');
      const name = this.eingabe('ansprechpartner');
      const mail = this.eingabe('email');
      [org, name, mail].forEach((el) => el && el.removeAttribute('aria-invalid'));
      if (!this.a.wer) {
        this.fehler('wer', 'Bitte wählt aus, für wen die Ausstecher sind.');
        fehlt.push(this.querySelector('[data-kl-wahl="wer"]'));
      }
      if (!this.a.menge && this.mengeFeld) fehlt.push(this.mengeFeld);
      const texte = [];
      if (org && !org.value.trim()) {
        org.setAttribute('aria-invalid', 'true');
        fehlt.push(org);
        texte.push('den Namen des Vereins oder der Firma');
      }
      if (name && !name.value.trim()) {
        name.setAttribute('aria-invalid', 'true');
        fehlt.push(name);
        texte.push('euren Namen');
      }
      if (mail && !/^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/.test(mail.value.trim())) {
        mail.setAttribute('aria-invalid', 'true');
        fehlt.push(mail);
        texte.push('eine gültige E-Mail-Adresse');
      }
      this.fehler('kontakt', texte.length ? `Bitte tragt noch ${texte.join(', ').replace(/, ([^,]*)$/, ' und $1')} ein.` : '');
      return fehlt.filter(Boolean);
    }

    /* ---------- Absenden ----------
       Shopify verlangt für Kontaktformulare ein hCaptcha-Token („Missing CAPTCHA token“ ohne). Das Token holt
       Shopifys eigenes Skript beim echten Absenden. Darum: nur prüfen und Felder füllen, dann das Absenden NICHT
       anhalten; Shopify schickt das Formular klassisch ab (das submit-Ereignis feuert, der Pixel /p/f sieht es),
       leitet auf return_to bzw. ?contact_posted=true zurück, und von dort geht es zur Danke-Seite. */
    absenden(e) {
      const halt = () => {
        e.preventDefault();
        e.stopImmediatePropagation(); // sonst schickt Shopifys Captcha-Skript das Formular trotzdem ab
      };
      if (this.modus === 'quiz' && this.aktuell !== 'kontakt') {
        halt();
        this.weiter();
        return;
      }
      // Zweites submit nach dem Captcha (Shopify schickt dann selbst ab): nicht aufhalten.
      if (this.sendet) return;
      if (this.upload && this.upload.laeuft) {
        halt();
        if (this.upload.hinweisZeigen) this.upload.hinweisZeigen();
        return;
      }
      this.felder();
      const fehlt = this.pruefen();
      if (fehlt.length) {
        halt();
        const erstes = fehlt[0];
        erstes.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (erstes.focus) erstes.focus({ preventScroll: true });
        return;
      }
      const ziel = this.zielAdresse();
      messenWennBereit(this.modus, 'absenden');
      // Bots füllen die Falle: so tun, als wäre alles gut, aber nichts senden.
      const falle = this.form.querySelector('[data-kl-falle]');
      if (falle && falle.value) {
        halt();
        location.href = ziel;
        return;
      }
      schreiben(SPEICHER, {
        funnel: this.modus,
        wer: this.a.wer,
        anlass: this.a.anlassText || '',
        menge: this.a.menge,
        preis: this.preisVorschau(),
        gesamt: preisJe(this.a.menge) ? euro(this.a.menge * preisJe(this.a.menge)) : '',
        termin: this.terminText(),
        org: this.feld('organisation').value,
        email: this.feld('email').value,
        datei: this.dateiName(),
        ziel,
        offen: true,
        am: Date.now(),
      });
      schreiben(KONVERSION, 'offen');
      // Knopf erst nach dem Absenden sperren (gesperrte Knöpfe stören das erneute Absenden nach dem Captcha nicht,
      // weil Shopify form.submit() benutzt). Kommt keine neue Seite (Captcha abgebrochen), wieder freigeben.
      setTimeout(() => this.laedt(true), 0);
      clearTimeout(this.freiUhr);
      this.freiUhr = setTimeout(() => this.laedt(false), 15000);
    }

    laedt(an) {
      this.sendet = an;
      this.querySelectorAll('[data-kl-senden]').forEach((k) => {
        if (an) {
          k.dataset.text = k.textContent;
          k.innerHTML = '<span class="kl-dreher" aria-hidden="true"></span>Wird gesendet';
          k.disabled = true;
        } else if (k.dataset.text) {
          k.textContent = k.dataset.text;
          k.disabled = false;
        }
      });
    }

    /* ---------- Seite ---------- */
    seiteEinrichten() {
      messenWennBereit('seite', 'start');
      // Erste Antwort (Kachel, Menge) und erstes Feld im Kontaktblock: wie weit kommt jemand auf der langen Seite?
      this.form.addEventListener('click', (e) => { if (e.target.closest('[data-kl-wahl], [data-kl-chip], [data-kl-plus], [data-kl-minus]')) messenWennBereit('seite', 'auswahl'); });
      this.form.addEventListener('input', (e) => { if (e.target.closest('[data-kl-block="menge"]')) messenWennBereit('seite', 'auswahl'); });
      const kontaktBlock = this.querySelector('[data-kl-block="kontakt"]');
      if (kontaktBlock) kontaktBlock.addEventListener('focusin', () => messenWennBereit('seite', 'kontakt'));
      const leiste = this.querySelector('[data-kl-leiste]');
      const menge = this.querySelector('[data-kl-block="menge"] .kl-preis'); // der grüne Preis-Kasten
      const kontakt = this.querySelector('[data-kl-block="kontakt"]');
      const senden = this.querySelector('.kl-senden');
      const zum = this.querySelector('[data-kl-zum-formular]');
      if (zum && kontakt)
        zum.addEventListener('click', () => {
          kontakt.scrollIntoView({ behavior: 'smooth', block: 'start' });
          const erstes = this.eingabe('organisation');
          if (erstes) setTimeout(() => erstes.focus({ preventScroll: true }), 450);
        });
      if (!leiste || !menge || !('IntersectionObserver' in window)) return;
      const sicht = { menge: true, kontakt: false, senden: false };
      const aktualisieren = () => {
        const ueberMenge = !sicht.menge && menge.getBoundingClientRect().top < 0;
        leiste.hidden = !(ueberMenge && !sicht.kontakt && !sicht.senden);
      };
      const io = new IntersectionObserver((eintraege) => {
        eintraege.forEach((x) => {
          if (x.target === menge) sicht.menge = x.isIntersecting;
          if (x.target === kontakt) sicht.kontakt = x.isIntersecting;
          if (x.target === senden) sicht.senden = x.isIntersecting;
        });
        aktualisieren();
      }, { rootMargin: '-60px 0px -30% 0px' }); // unten erst, wenn das Formular richtig im Blick ist
      [menge, kontakt, senden].forEach((el) => el && io.observe(el));
    }

    /* ---------- Quiz ---------- */
    quizEinrichten() {
      this.reihe = ['wer', 'menge', 'termin', 'logo', 'kontakt'];
      this.aktuell = 'wer';
      this.querySelectorAll('[data-kl-weiter]').forEach((k) => k.addEventListener('click', () => this.weiter()));
      const zurueck = this.querySelector('[data-kl-zurueck]');
      // Eigener Verlauf statt history.pushState: Klaviyos Exit-Intent am Handy hängt sich an die Zurück-Taste.
      this.verlauf = [];
      if (zurueck)
        zurueck.addEventListener('click', () => {
          const s = this.verlauf.pop();
          if (s) this.zeige(s, false);
        });
      const wenigKnopf = this.querySelector('[data-kl-wenig-knopf]');
      if (wenigKnopf) wenigKnopf.addEventListener('click', () => this.zeige('unter50', true));
      const trotzdem = this.querySelector('[data-kl-trotzdem]');
      const wenigZahl = this.querySelector('[data-kl-wenig-zahl]');
      if (trotzdem)
        trotzdem.addEventListener('click', () => {
          const n = parseInt(String(wenigZahl ? wenigZahl.value : '').replace(/\D/g, ''), 10) || 0;
          if (n) this.setzeMenge(Math.min(n, AB - 1));
          this.zeige('termin', true);
        });
      this.zeige('wer', false);
    }

    spaeterWeiter() {
      clearTimeout(this.weiterUhr);
      this.weiterUhr = setTimeout(() => this.weiter(), 230);
    }

    weiter() {
      const s = this.aktuell;
      if (s === 'menge' && this.a.menge > 0 && this.a.menge < AB) return this.zeige('unter50', true);
      if (s === 'menge' && !this.a.menge) return;
      if (s === 'unter50') return this.zeige('termin', true);
      if (s === 'termin' && this.a.terminArt === 'eigenes Datum' && !ausIso(this.a.datum)) return;
      if (s === 'termin' && !this.a.terminArt) return;
      const i = this.reihe.indexOf(s);
      if (i >= 0 && i < this.reihe.length - 1) this.zeige(this.reihe[i + 1], true);
    }

    zeige(schritt, merken) {
      this.aktuell = schritt;
      messenWennBereit('quiz', schritt);
      this.querySelectorAll('[data-kl-schritt]').forEach((el) => (el.hidden = el.dataset.klSchritt !== schritt));
      const i = this.reihe.indexOf(schritt === 'unter50' ? 'menge' : schritt);
      const balken = this.querySelector('[data-kl-balken]');
      if (balken) {
        balken.querySelector('i').style.width = `${((i + 1) / this.reihe.length) * 100}%`;
        balken.setAttribute('aria-valuenow', String(i + 1));
      }
      const nr = this.querySelector('[data-kl-schritt-nr]');
      if (nr) nr.textContent = `${i + 1} / ${this.reihe.length}`;
      const zurueck = this.querySelector('[data-kl-zurueck]');
      if (zurueck) {
        const an = this.verlauf.length > 0;
        zurueck.setAttribute('aria-hidden', String(!an));
        zurueck.tabIndex = an ? 0 : -1;
      }
      if (merken && this.vorher && this.vorher !== schritt) this.verlauf.push(this.vorher);
      this.vorher = schritt;
      if (schritt === 'kontakt') {
        const teile = [];
        const p = preisJe(this.a.menge);
        if (this.a.menge) teile.push(p ? `${zahl(this.a.menge)} Ausstecher für ${euro(this.a.menge * p)}` : `${zahl(this.a.menge)} Ausstecher`);
        if (this.a.anlassText) teile.push(this.a.anlassText);
        if (this.terminText()) teile.push(this.terminText());
        const z = this.querySelector('[data-kl-zusammen]');
        if (z) {
          z.textContent = teile.join(' · ');
          z.hidden = !teile.length;
        }
      }
      const kopf = this.querySelector(`[data-kl-schritt="${schritt}"] h1, [data-kl-schritt="${schritt}"] h2`);
      // Nur nach oben, wenn der Anfang des Quiz nicht zu sehen ist (kein Springen bei jedem Schritt).
      const oben = this.getBoundingClientRect().top;
      if (oben < 0) window.scrollTo({ top: Math.max(0, window.scrollY + oben - 8) });
      if (kopf && merken) kopf.focus({ preventScroll: true });
    }
  }
  if (!customElements.get('keks-lead')) customElements.define('keks-lead', KeksLead);

  /* ---------- Danke-Seite ---------- */
  class KeksLeadDanke extends HTMLElement {
    connectedCallback() {
      const p = lesen(SPEICHER);
      if (!p) return;
      const zeilen = [
        ['Für', [p.org, p.wer && `(${p.wer})`].filter(Boolean).join(' ')],
        ['Anlass', p.anlass],
        ['Stückzahl', p.menge ? zahl(p.menge) : ''],
        ['Preis', p.gesamt ? `${p.gesamt} inkl. MwSt.` : p.menge ? 'Mengenpreis ab 50 Stück' : ''],
        ['Termin', p.termin],
        ['Wappen oder Logo', p.datei || 'kommt per Mail'],
        ['Antwort an', p.email],
      ].filter(([, v]) => v);
      const dl = this.querySelector('[data-kl-danke-zeilen]');
      if (dl && zeilen.length) {
        dl.innerHTML = '';
        zeilen.forEach(([k, v]) => {
          const div = document.createElement('div');
          const dt = document.createElement('dt');
          const dd = document.createElement('dd');
          dt.textContent = k;
          dd.textContent = v;
          div.append(dt, dd);
          dl.append(div);
        });
        this.querySelector('[data-kl-danke-zusammen]').hidden = false;
      }
      const logo = this.querySelector('[data-kl-danke-logo]');
      if (logo) logo.hidden = Boolean(p.datei);
      const lead = this.querySelector('[data-kl-danke-lead]');
      if (lead && p.datei)
        lead.textContent = 'Wir melden uns in der Regel innerhalb eines Werktags per Mail. Mit eurem Logo zeichnen wir gleich den Entwurf, ihr bekommt Angebot und Entwurf zusammen.';
      else if (lead) lead.textContent = 'Wir melden uns in der Regel innerhalb eines Werktags per Mail mit eurem Angebot.';
    }
  }
  if (!customElements.get('keks-lead-danke')) customElements.define('keks-lead-danke', KeksLeadDanke);
})();
